import PostCustomerOrderRequestModelBase from '../_generated/modelBases/post-customer-order-request-model-base';

export default class PostCustomerOrderRequestModel extends PostCustomerOrderRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
